const isEmpty = (value) =>
  value === null || value === undefined || value === '' || Number.isNaN(value);

export default isEmpty;
